const externalRoutes = {
  Banking: {
    downloadStatements:
      import.meta.env.VITE_API_URL + "/api/front/accounts/download",
    downloadTransactions:
      import.meta.env.VITE_API_URL + "/api/front/transactions/download",
  },
  Stripe: {
    root: `https://billing.stripe.com/p/login/${
      import.meta.env.VITE_STRIPE_LOGIN
    }`,
  },
};

export default externalRoutes;
